import React from 'react';
import { Link } from 'react-router-dom'
import {Row,Col, Grid} from 'react-bootstrap'
import RaisedButton from 'material-ui/RaisedButton';
import * as actions from '../../Actions/index.js';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

class Unsubscribe extends React.Component{
  constructor(props){
    super(props);
    this.state={
        cancelDokkitMessage: ''  ,
        messageReq: ''  ,
        buttonDisable: false,  
    };
    this.submitCancelMsg= this.submitCancelMsg.bind(this);

    

  }
  componentWillReceiveProps(nextProps){   
    let checkButtonstatus=nextProps.company.disableCancelDokkitMailButton;
    this.setState({buttonDisable:checkButtonstatus});
  }
  // submit cancel dokkit message
  submitCancelMsg(e){
    e.preventDefault();
    const {history:{location:{state:{userId}}}} = this.props
    let message= document.cancelDokkit.message.value;
    if(message===''){
      this.setState({messageReq: 'Please mention your comments'});
      return false;
    }
    if(message){
      this.setState({buttonDisable:true});
      this.setState({messageReq: ''});
      this.props.sendMailCancelDokkit(message, userId);
    }
  }
  render() {
      let today = new Date().getFullYear()
      return(<div className="thankyou-page unsubscribe">
                  <Grid>
                    <Row>
                      <Col md={12}>
                          <div className="thankyou-logo">
                              <Link to="#">
                                <img src="/images/dokkit-logo.png" alt="logo" />
                              </Link>
                          </div>
                          <div className="display-flex-align">
                            <div className="margin-auto">
                                <h2>You have successfully cancelled your subscription.</h2>
                                <h4>If you have a moment, please let us know why you unsubscribed:</h4>
                                <Row>
                                
                                        
                                <form name="cancelDokkit" onSubmit={this.submitCancelMsg}>
                                  <Col md={12}>
                                  {this.state.messageReq?
                                          <p style={{color: '#ff0000'}}>Please give an appropriate reason. </p>
                                          : null
                                        }
                                  {this.props.company.sendCancelDokkitMail?
                                          <p style={{color: '#33cc33'}}>Thank you! Your message was sent successfully.</p>
                                          : null
                                        }
                                    <div className="unsubscribe-form">
                                        
                                       <textarea name="message" placeholder="write message" ></textarea>
                                         <RaisedButton 
                                          label="SUBMIT" 
                                          type="submit"
                                          labelColor="#fff" 
                                          labelStyle={{'fontWeight': '600'}}
                                          fullWidth={true} 
                                          disabled={this.state.buttonDisable?true:false}

                                        />
                                    </div>
                                  </Col>
                                </form>
                                </Row>
                            </div>
                          </div>
                          <div className="copyright-footer">
                              <p>&copy; {today.toString()} Dokkit All rights reserved.</p>
                          </div>
                      </Col>
                    </Row>
                  </Grid>
             </div>    
      )
    }
}

const mapStateToProps= (state,props)=> {
    return {
      company: state.company
    };
}
export default connect(mapStateToProps,actions)(Unsubscribe)




// WEBPACK FOOTER //
// ./src/Components/Pages/Unsubscribe.js